<nav class="navbar navbar-expand-lg px-0 topbar">
  <div class="collapse navbar-collapse">
    @if (settings?.is_demo_enabled) {
      <div class="v-text-primary small"><i class="lnr lnr-warning me-2" aria-hidden="true"></i><span>{{ 'TOPBAR.DEMO.PART1' | translate }}</span><a class="fw-bold v-text-primary" [href]="billingUrl" target="_blank">{{ 'TOPBAR.DEMO.CTA1' | translate }}</a><span>{{ 'TOPBAR.DEMO.PART2' | translate }}</span><a class="fw-bold v-text-primary" href="https://calendly.com/vitay/vitay_demo" target="_blank" rel="noopener noreferrer">{{ 'TOPBAR.DEMO.CTA2' | translate }}</a><span>{{ 'TOPBAR.DEMO.PART3' | translate }}</span></div>
      }@if (isSearchbarEnabled && !settings?.is_demo_enabled) {
      <app-typeahead class="w-50" [isAdvancedSearchEnable]="true" (selectService)="onSelectService($event)" [service]="service" [resourceName]="resourceName" [onMatOptionSelect]="onMatOptionSelect" [instanceId]="'magnifying-search'"></app-typeahead>
    }
    <ul class="navbar-nav ms-auto">
      <li class="nav-item v-nav-item me-2"><a class="nav-link text-center" [routerLink]="['/logout']" [tooltip]="'TOPBAR.TOOLTIPS.LOGOUT' | translate" container="body" placement="bottom" [attr.aria-label]="'TOPBAR.TOOLTIPS.LOGOUT' | translate"><i class="lnr lnr-exit" aria-hidden="true"></i></a></li>
      @if (!isWhiteLabelEnabled && shouldShow('help')) {
        <li class="nav-item v-nav-item me-2" [popover]="helpTemplate" placement="bottom" triggers="click" [outsideClick]="true" containerClass="v-popover-apps">
          <div class="nav-link text-center" [tooltip]="'TOPBAR.TOOLTIPS.HELP' | translate" container="body" placement="bottom"><i class="lnr lnr-question-circle" aria-hidden="true"></i></div>
        </li>
      }
      @if (shouldShow('search')) {
        <li class="nav-item v-nav-item me-2">
          <div class="nav-link text-center" (click)="isSearchbarEnabled = !isSearchbarEnabled" [tooltip]="'TOPBAR.TOOLTIPS.SEARCH' | translate" container="body" placement="bottom"><i class="lnr lnr-magnifier" aria-hidden="true"></i></div>
        </li>
      }
      @if (shouldShow('notifications')) {
        <li class="nav-item v-nav-item me-2"><app-announcement-badge></app-announcement-badge></li>
      }
      @if ((settings?.is_reports_downloadable || isRoot) && shouldShow('download')) {
        <li class="nav-item v-nav-item me-2">
          <div class="nav-link text-center" (click)="openModal()" [tooltip]="'TOPBAR.TOOLTIPS.DOWNLOAD' | translate" container="body" placement="bottom"><i class="lnr lnr-download2" aria-hidden="true"></i></div>
        </li>
      }
      @if (shouldShow('apps')) {
        <li class="nav-item v-nav-item me-2" [popover]="appsTemplate" placement="bottom" triggers="click" [outsideClick]="true" containerClass="v-popover-apps">
          <div class="nav-link text-center" [tooltip]="'TOPBAR.TOOLTIPS.APPS' | translate" container="body" placement="bottom"><i class="lnr lnr-icons" aria-hidden="true"></i></div>
        </li>
      }
      <li class="nav-item v-nav-item"><a class="nav-link text-center" [routerLink]="['/account/information']" routerLinkActive="active" [tooltip]="'TOPBAR.TOOLTIPS.ACCOUNT' | translate" container="body" placement="bottom" [attr.aria-label]="'TOPBAR.TOOLTIPS.ACCOUNT' | translate"><i class="lnr lnr-user" aria-hidden="true"></i></a></li>
      @if (companies?.length > 1) {
        <li class="nav-item v-nav-item company-switcher">
          <div class="btn-group" dropdown="dropdown" placement="bottom right">
            <button class="nav-link" type="button" dropdownToggle="dropdownToggle" [attr.aria-label]="'TOPBAR.ACCOUNTS.SWITCH' | translate" [title]="hiringFirm?.name">
              <span class="company-pill company-pill--switchable">
                <span class="company-picture" [style.background-image]="'url(' + hiringFirm?.logo_url + ')'" aria-hidden="true"></span>
                <span class="company-name">{{ hiringFirm?.name }}</span>
                <i class="lnr lnr-chevron-down company-chevron" aria-hidden="true"></i>
              </span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end company-menu" role="menu" *dropdownMenu="">
              <li><h6 class="dropdown-header">{{ 'TOPBAR.ACCOUNTS.SWITCH' | translate }}</h6></li>
              @for (c of companies; track c.id) {
                <li role="menuitem">
                  <button class="dropdown-item" type="button" [class.active]="c.id === hiringFirm?.id" [attr.aria-current]="c.id === hiringFirm?.id ? 'true' : null" (click)="onChangeCompanies(c.id)">
                    <img [src]="c.logo_url" width="24" height="24" alt="" /><span class="company-menu-label">{{ c.name }}</span>
                    @if (c.id === hiringFirm?.id) {
                      <i class="lnr lnr-checkmark-circle company-check" aria-hidden="true"></i>
                    }
                  </button>
                </li>
              }
            </ul>
          </div>
        </li>
      }
      @if (companies?.length === 1) {
        <li class="nav-item v-nav-item company-switcher company-switcher--static">
          <div class="nav-link" [title]="hiringFirm?.name">
            <span class="company-pill">
              <span class="company-picture" [style.background-image]="'url(' + hiringFirm?.logo_url + ')'" aria-hidden="true"></span>
              <span class="company-name">{{ hiringFirm?.name }}</span>
            </span>
          </div>
        </li>
      }
    </ul>
  </div>
</nav><ng-template #popTemplate="">
<ul class="list-unstyled">
  @if (rows?.length === 0) {
    <li class="nav-item small text-center">{{ 'TOPBAR.NOTIFICATIONS.EMPTY' | translate }}</li>
  }
  @for (a of rows; track trackByFn(a); let last = $last) {
    <li class="nav-item" [ngClass]="{ 'pb-2': !last }">
      <div class="row small">
        <div class="col-8" [innerHTML]="a.description | translatable"></div>
        <div class="col-4 text-end">{{ a.created_at | ago }}</div>
      </div>
    </li>
  }
  <li class="nav-item text-end mt-2">
    <div class="d-grid"><button class="btn btn-sm v-btn v-btn-primary" type="button" (click)="getActivities()"><i class="lnr lnr-refresh me-2" aria-hidden="true"></i>{{ 'BUTTONS.REFRESH' | translate : { type : 'activities' } }}</button></div>
  </li>
</ul>
</ng-template><ng-template #appsTemplate="">
@for (a of apps; track a) {
  <div class="v-popover-apps-app d-inline-flex align-items-center" [ngClass]="{ 'v--opacity-50': a.isDisabled }" (click)="goTo(a)">
    <div class="w-100 text-center"><img class="mx-auto d-block" [src]="a.src" width="25" height="25" [alt]="a.label" />
      <div class="mt-2 text-muted small text-capitalize">{{ a.label }}</div>
    </div>
  </div>
}
</ng-template><ng-template #helpTemplate="">
<ul class="list-group list-group-flush">
  <li class="list-group-item list-group-item-action p-2"><a class="nav-link" href="https://vimeo.com/510463975" target="_blank" tooltip="password: vitay2021" container="body">{{ 'TOPBAR.HELP.DEMO_VIDEO' | translate }}</a></li>
  <li class="list-group-item list-group-item-action p-2"><a class="nav-link" href="https://vitay.io/faq/" target="_blank">{{ 'TOPBAR.HELP.FAQ' | translate }}</a></li>
</ul>
</ng-template><app-modals-export [openModal]="openExportModal"></app-modals-export>@if (shouldShow('notifications')) {
<app-announcement-sidebar></app-announcement-sidebar>
}
